import React, { Component } from "react";

import FullWidthCard from "../post/full-width-card";

/**
 * Renders the grid/list of case study cards (all are double width).
 */
class ReportList extends Component 
{
    render () {
        const reports = this.props.reports;
        const services = this.props.services;
        
        return (
            <div className="blog-card-grid">
                { reports.map((report, index) => {
                    // generate a random key to stop <Fade> from caching
                    return (
                        <FullWidthCard 
                            key={ `report-card-${index}` } 
                            data={ report } 
                            services = { services }
                        />
                    );
                }) }
            </div>
        );
    }
}

export default ReportList;